/**
 * CTR Product Cards – toggle subscription + add-to-cart + Swiper slider
 */
(function () {
  function initSection(section) {
    var sectionId = section.dataset.sectionId;
    var swiperEl = section.querySelector('[data-ctr-pc-swiper]');
    if (!swiperEl) return;

    var jsonEl = section.querySelector('[data-ctr-pc-product="' + sectionId + '"]');
    var productData = null;
    if (jsonEl) {
      try {
        productData = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }
    }
    if (!productData) return;

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 2
      }).format(cents / 100);
    }

    function getVariant(id) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(function (v) {
        return v.id == id;
      });
    }

    /* ── Toggle logic ── */
section.addEventListener('change', function (e) {
  var toggle = e.target.closest('[data-ctr-pc-toggle]');
  if (!toggle) return;

  var card = toggle.closest('[data-ctr-pc-card]');
  var variantId = toggle.dataset.variantId;
  var variant = getVariant(variantId);
  if (!variant) return;

  var atcBtn = card.querySelector('[data-ctr-pc-atc]');
  var priceEl = card.querySelector('[data-ctr-pc-price]');
  var compareEl = card.querySelector('[data-ctr-pc-compare]');
  var saveEl = card.querySelector('[data-ctr-pc-save]');
  var isSubscription = toggle.checked;

  var currentPrice = variant.price;
  var comparePrice = variant.compare_at_price;

  if (isSubscription && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
    var alloc = variant.selling_plan_allocations[0];
    currentPrice = alloc.price;
    if (!comparePrice) comparePrice = variant.price;
    if (atcBtn) atcBtn.dataset.sellingPlanId = alloc.selling_plan_id;
  } else {
    if (atcBtn) atcBtn.dataset.sellingPlanId = '';
  }

  if (priceEl) priceEl.textContent = formatMoney(currentPrice);

  if (compareEl) {
    if (comparePrice && comparePrice > currentPrice) {
      compareEl.textContent = formatMoney(comparePrice);
      compareEl.style.display = '';
    } else {
      compareEl.textContent = '';
      compareEl.style.display = 'none';
    }
  }

  if (saveEl) {
    if (comparePrice && comparePrice > currentPrice) {
      var pct = Math.round((comparePrice - currentPrice) / comparePrice * 100);
      saveEl.textContent = 'Save ' + pct + '%';
      saveEl.style.display = '';
    } else {
      saveEl.textContent = '';
      saveEl.style.display = 'none';
    }
  }

  var shippingEl = card.querySelector('[data-ctr-pc-shipping]');
  if (shippingEl) {
    shippingEl.style.display = isSubscription ? '' : 'none';
  }
});



    /* ── Add to Cart ── */
    function getCart() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    var atcButtons = section.querySelectorAll('[data-ctr-pc-atc]');
    atcButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var cartEl = getCart();
        var variantId = btn.dataset.variantId;
        var sellingPlanId = btn.dataset.sellingPlanId || '';

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        var card = btn.closest('[data-ctr-pc-card]');
        var toggle = card ? card.querySelector('[data-ctr-pc-toggle]') : null;
        var isSubscription = toggle ? toggle.checked : false;

        if (isSubscription && !sellingPlanId) {
          var variant = getVariant(variantId);
          if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
            sellingPlanId = variant.selling_plan_allocations[0].selling_plan_id;
          }
        }

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (isSubscription && sellingPlanId) {
          formData.append('selling_plan', sellingPlanId);
        }

        var existingForm = document.querySelector('form[data-type="add-to-cart-form"]');
        if (existingForm) {
          existingForm.querySelectorAll('input[name^="properties"]').forEach(function (input) {
            if (input.name && input.value) {
              formData.append(input.name, input.value);
            }
          });
        }

        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          formData.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }));
          formData.append('sections_url', window.location.pathname);
          cartEl.setActiveElement(document.activeElement);
        }

        config.body = formData;

        btn.disabled = true;
        var originalText = btn.textContent.trim();
        btn.textContent = 'Adding...';

        fetch(routes.cart_add_url, config)
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status) {
              console.error('[ctr-product-cards] ATC error:', response.description || response.message);
              btn.textContent = originalText;
              btn.disabled = false;
              return;
            }

            if (!cartEl) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'ctr-product-cards',
                productVariantId: variantId,
                cartData: response
              });
            }

            cartEl.renderContents(response);

            btn.textContent = 'Added!';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          })
          .catch(function (err) {
            console.error('[ctr-product-cards] ATC fetch error:', err);
            btn.textContent = originalText;
            btn.disabled = false;
          })
          .finally(function () {
            if (cartEl && cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
          });
      });
    });

    /* ── Swiper Slider ── */
    new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 20,
      slidesPerGroup: 1,
      navigation: {
        prevEl: section.querySelector('[data-ctr-pc-prev]'),
        nextEl: section.querySelector('[data-ctr-pc-next]')
      },
      pagination: {
        el: section.querySelector('[data-ctr-pc-dots]'),
        clickable: true,
        bulletClass: 'ctr-product-cards__dot',
        bulletActiveClass: 'ctr-product-cards__dot--active'
      },
      breakpoints: {
        1200: {
          slidesPerView: 3,
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('.ctr-product-cards').forEach(initSection);
  }

  if (typeof Swiper === 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      var check = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          clearInterval(check);
          init();
        }
      }, 50);
    });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
